import { render, staticRenderFns } from "./LogReserve.vue?vue&type=template&id=4f761880&scoped=true&"
import script from "./LogReserve.vue?vue&type=script&lang=js&"
export * from "./LogReserve.vue?vue&type=script&lang=js&"
import style0 from "./LogReserve.vue?vue&type=style&index=0&id=4f761880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f761880",
  null
  
)

export default component.exports